import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { MessageCircle, Globe } from 'lucide-react';
import { trackLead } from '../lib/metaPixel';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  return <section id="book" className="relative py-32 overflow-hidden flex items-center justify-center" data-id="element-52">
      <div className="absolute inset-0" data-id="element-53">
        <img src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=2000&auto=format&fit=crop" alt="Turquoise Caribbean beach in Puerto Rico" className="w-full h-full object-cover object-center" data-id="element-54" />
        <div className="absolute inset-0 bg-ocean-dark/80 mix-blend-multiply" data-id="element-55" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center" data-id="element-56">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-5xl md:text-6xl font-heading font-bold text-white mb-12 drop-shadow-lg" data-id="element-57">
          {t.finalCta.headline}
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-58">
          <a href="https://wa.link/qca29f" target="_blank" rel="noreferrer" onClick={trackLead} className="flex items-center justify-center gap-2 bg-turquoise hover:bg-turquoise-light text-white px-8 py-4 rounded-full font-bold text-lg transition-all hover:scale-105 shadow-xl w-full sm:w-auto" data-id="element-59">
            <MessageCircle size={20} data-id="element-60" />
            {t.finalCta.btnWhatsapp}
          </a>
          <a href="https://bluoceantours.com/booking" target="_blank" rel="noreferrer" onClick={trackLead} className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white px-8 py-4 rounded-full font-bold text-lg transition-all hover:scale-105 w-full sm:w-auto" data-id="element-61">
            <Globe size={20} data-id="element-62" />
            {t.finalCta.btnWebsite}
          </a>
        </motion.div>
      </div>
    </section>;
}